import * as React from "react";
import { SVGProps } from "react";

const Chimpion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 43 38"
    {...props}
  >
    <style>{".st0{fill:#3b3f4c}"}</style>
    <g
      id="\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C_775"
      transform="translate(1120.897 -326.692)"
    >
      <path
        id="\u041A\u043E\u043D\u0442\u0443\u0440_5101"
        d="M-1077.1 344.2c0-1.8-2-2.8-2.7-3.1-2.4-8.6-10.3-14.5-19.2-14.4-8.9-.1-16.8 5.8-19.2 14.4-.6.3-2.7 1.2-2.7 3.1 0 2.2-.3 4.3 0 5.3.4 1.3 1.6 2.2 2.9 2.3.8 2.8 2.3 5.4 4.3 7.5 3.6 3.7 8.6 5.6 14.6 5.6s11-1.9 14.6-5.6c2-2.1 3.5-4.7 4.3-7.5 1.4-.1 2.5-1 2.9-2.3.5-1 .2-3.1.2-5.3zm-3.5 1.5c0 10.6-7.4 17.7-18.3 17.7s-18.3-7.1-18.3-17.7c0-9.7 8.2-17.6 18.3-17.6s18.3 7.9 18.3 17.6z"
        className="st0"
      />
      <g
        id="\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C_774"
        transform="translate(6.917 8.66)"
      >
        <path
          id="\u041A\u043E\u043D\u0442\u0443\u0440_5102"
          d="M-1108.7 334.2c0-1.5-1.2-2.7-2.7-2.7-1.5 0-2.7 1.2-2.7 2.7 0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.7-1.2 2.7-2.7z"
          className="st0"
        />
        <path
          id="\u041A\u043E\u043D\u0442\u0443\u0440_5103"
          d="M-1104.8 341.5c.3 0 .6-.3.6-.6s-.3-.6-.6-.6-.6.3-.6.6.2.6.6.6z"
          className="st0"
        />
        <path
          id="\u041A\u043E\u043D\u0442\u0443\u0440_5104"
          d="M-1110 344.1c0 2.2 1.8 3.9 3.9 3.9h.1c2.2.1 4-1.6 4.1-3.8v-.1c-1.3.5-2.7.8-4.1.9-1.4 0-2.7-.3-4-.9z"
          className="st0"
        />
        <path
          id="\u041A\u043E\u043D\u0442\u0443\u0440_5105"
          d="M-1107 341.5c.3 0 .6-.3.6-.6s-.3-.6-.6-.6-.6.3-.6.6.3.6.6.6z"
          className="st0"
        />
        <path
          id="\u041A\u043E\u043D\u0442\u0443\u0440_5106"
          d="M-1100.1 331.4c-1.5 0-2.7 1.2-2.7 2.7 0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.7-1.2 2.7-2.7 0-1.4-1.2-2.6-2.7-2.7z"
          className="st0"
        />
        <path
          id="\u041A\u043E\u043D\u0442\u0443\u0440_5107"
          d="M-1097.7 327.2c-2.7-.5-5.5-.7-8.2-.5-2.8-.1-5.6 0-8.4.6-6.4 1.7-6.7 6.2-6.7 11s2.1 9.9 7.8 12.2c2 .8 4.4.9 7.4.9s5.4-.1 7.3-.9c5.7-2.3 7.5-7.4 7.5-12.2.2-4.9-.1-9.4-6.7-11.1zm-2.6 13.1h-.4c.5 1.3.7 2.7.8 4 0 3.4-2.7 6.1-6.1 6.1-3.4 0-6.1-2.8-6.1-6.1.1-1.4.3-2.7.8-4h-.2c-3.4 0-6.1-2.8-6.1-6.1 0-3.4 2.7-6.1 6.1-6.1 2.4 0 4.7 1.5 5.6 3.7.9-2.3 3.1-3.7 5.6-3.7 3.4 0 6.1 2.8 6.1 6.1s-2.7 6.1-6.1 6.1z"
          className="st0"
        />
      </g>
    </g>
  </svg>
);

export default Chimpion;
